import { Injectable } from '@angular/core';
import { SectionsSubjects, LmsSectionSubject } from '../../_models';
import { Observable, forkJoin, Subject } from 'rxjs';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';
import { LmsService } from './lms.service';

@Injectable({
  providedIn: 'root'
})
export class SectionsSubjectsService {
  private apiUrl = environment.apiUrl;

  private subject = new Subject<any>();
  sendGetAllSubjectsOrder() {
    this.subject.next();
  }

  clearMessage() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }






  constructor(private http: HttpClient) { }

  getAllByClassIdAndSectionId(classId: number, sectionId?: number): Observable<LmsSectionSubject[]> {
    const url = `${this.apiUrl}/SectionSubjects/GetAllByClassIdAndSectionId/${classId} ${sectionId ? `/${sectionId}` : ``} `;
    return this.http.get<LmsSectionSubject[]>(url);
  }

  getById(sectionsSubjectId: number): Observable<SectionsSubjects> {
    const url = `${this.apiUrl}/SectionSubjects/GetById/${sectionsSubjectId}`;
    return this.http.get<SectionsSubjects>(url);
  }

  getSiblingBySectionSubjectIdWithSection(sectionSubjectId: number): Observable<LmsSectionSubject[]> {
    const url = `${this.apiUrl}/SectionSubjects/GetSiblingBySectionSubjectIdWithSection/${sectionSubjectId}`;
    return this.http.get<LmsSectionSubject[]>(url);
  }

  getSiblingBySectionSubjectIdWithSectionForSemesterPlan(sectionSubjectId: number, semesterPlanId: number): Observable<LmsSectionSubject[]> {
    const url = `${this.apiUrl}/SectionSubjects/GetSiblingBySectionSubjectIdWithSectionForSemesterPlan/${sectionSubjectId}${semesterPlanId ? '/' + semesterPlanId : ''}`;
    return this.http.get<LmsSectionSubject[]>(url);
  }

  getAll() {
    return this.http.get(`${this.apiUrl}/SectionSubjects/GetAll`);
  }
  getAllBySection(id: number) {
    // observable of SectionSubjectLookup
    return this.http.get(`${this.apiUrl}/SectionSubjects/GetAllBySection/${id}`);
  }

  create(sectionSubject: SectionsSubjects) {
    return this.http.post(`${this.apiUrl}SectionSubjects/Add`, sectionSubject);
  }

  createBulk(bulkObj: { sectionSubjects: SectionsSubjects, sections: number[] }) {
    return this.http.post(`${this.apiUrl}SectionSubjects/AddBulk`, bulkObj);
  }

  getCoreBySectionId(sectionId: number) {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetCoreBySectionId/${sectionId}`);
  }

  getElectiveSectionId(sectionId: number) {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetElectiveSectionId/${sectionId}`);
  }

  delete(sectionSubjectId: number) {
    return this.http.delete(`${this.apiUrl}SectionSubjects/Delete/${sectionSubjectId}`);
  }

  update(sectionSubject: SectionsSubjects) {
    return this.http.put(`${this.apiUrl}SectionSubjects/Update`, sectionSubject);
  }

  getCoreAndEleciveSectionSubjects(sectionId: number) {
    return forkJoin(
      this.http.get(`${this.apiUrl}SectionSubjects/GetCoreBySectionId/${sectionId}`),
      this.http.get(`${this.apiUrl}SectionSubjects/GetElectiveSectionId/${sectionId}`)
    );
  }
  GetAllSectionSubjectTeacher(sectionId: number) {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetAllSectionSubjectTeacherWeb/${sectionId}`);
  }
  GetAllSubjectTeatcherBySection(sectionId: number) {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetAllSubjectTeatcherBySection/${sectionId}`)

  }

  getByIdWithTeacherAllocationsAndSectionWithClass(sectionSubjectId: number): Observable<LmsSectionSubject> {
    const url = `${this.apiUrl}/SectionSubjects/GetByIdWithTeacherAllocationsAndSectionWithClass/${sectionSubjectId}`;
    return this.http.get<LmsSectionSubject>(url)
      .pipe(tap(item => {
        this.checkIsSubjectHasCurriculumItems(item.subjectId);
        return item;
      }));
  }

  private checkIsSubjectHasCurriculumItems(subjectId: number) {
    this.http.get<boolean>(`${this.apiUrl}/CurriculumItem/GetIsSubjectHasCurriculumItems/${subjectId}`)
      .subscribe(val => {
        LmsService.isCurriculumHasCurriculumItems = val;
      });
  }

  sectionSubjectSearch(val:string)
  {
    return this.http.get(`${this.apiUrl}SectionSubjects/SectionSubjectSearch?name=${val}`); 
  }
  
  getSectionSubjectsByAsmtCategoryId(categoryId:number)
  {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetSectionSubjectsByAsmtCategoryId?categoryId=${categoryId}`); 
  }

  GetSectionSubjectsAsmtCategoryDetails(sectionSubjectId:number)
  {
    return this.http.get(`${this.apiUrl}SectionSubjects/GetSectionSubjectsAsmtCategoryDetails/${sectionSubjectId}`); 
  }
  
}
